import {
  MENU_ALL,
  MENU_NOT_CLASSIFY
} from '@components/LocalMerchant/Case/constant'
import { isSiDaMember } from '@util'
import { Button } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import CateForm from '../../../Common/CateForm'
import store from '../../../store'
import style from './index.module.less'
import MenuItem, { DragableItem } from './menuItem'

@observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      formValue: {}
    }
  }
  submitCasseCate = values => {
    this.setState({
      visible: false
    })
    store.submitCasseCate(values)
  }
  editCaseCate = (e, formValue) => {
    e.stopPropagation()
    this.setState({
      visible: true,
      formValue
    })
  }

  render() {
    const { menuList, isSort } = store
    return (
      <Fragment>
        <ul className={style.menu}>
          {menuList.map((item, index) => {
            const canSort =
              !isSort &&
              item.id != MENU_ALL &&
              item.id != MENU_NOT_CLASSIFY &&
              !isSiDaMember()
            if (canSort) {
              return (
                <DragableItem
                  item={item}
                  key={item.id}
                  index={index}
                  canSort={canSort}
                  editCaseCate={this.editCaseCate}
                />
              )
            }
            return (
              <MenuItem
                item={item}
                key={item.id}
                index={index}
                canSort={canSort}
                editCaseCate={this.editCaseCate}
              />
            )
          })}
          {!isSiDaMember() && (
            <li style={{ marginTop: '8px', marginLeft: '20px' }}>
              <Button
                onClick={() => this.setState({ visible: true, formValue: {} })}
              >
                新建分类
              </Button>
            </li>
          )}
        </ul>
        <CateForm
          visible={this.state.visible}
          onClose={() => this.setState({ visible: false })}
          onOk={this.submitCasseCate}
          formValue={this.state.formValue}
        />
      </Fragment>
    )
  }
}

export default Index
